import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { saveSortingHistory, applyConfiguration, getStaffList } from '../../../../actions/saActions';
import { handleLoadBatchIdDialogSlot, handleSaveDispatchHistoryDialogSlot, showAlertSnackbar, getOpenSaveDispatchHistoryDialogSlot, getSelectedBatchIds } from '../../../../reducers/uiSlice';
import UniDialog from '../../../../components/Common/UniDialog';
import { getUserPreference } from '../../../../utilities/common';
import SaveReplace from '../SaveReplece';
import { Button, IconButton, MenuItem, Select, Tooltip, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { FileCopy, Report } from '@material-ui/icons';
import { TextField } from '@material-ui/core';
import DoneIcon from '@material-ui/icons/Done';
import NotInterestedOutlinedIcon from '@material-ui/icons/NotInterestedOutlined';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme)=> ({
    container: {
        paddingBottom: 10
    },
    batchAction: {
        justifyContent: 'flex-end',
        paddingBottom: 10
    },
    batchInfo: {
        justifyContent: 'space-between',
    },
    row: {
        display: 'flex',
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center',
        color: 'white'
    },
    buttonStyle: {
        marginLeft: 10
    }
}))

function BatchInfo(props){
    const classes = useStyles();
    const {t} = useTranslation('slotAssignment');
    const dispatch = useDispatch();
    let openSaveDispatchHistoryDialog = useSelector(getOpenSaveDispatchHistoryDialogSlot);
    let selectedBatchIds = useSelector(getSelectedBatchIds);
    let userPref = getUserPreference();
    let patternIdTypes = useSelector(state => state.saReducer.getPatternIdType);

    const [dispatchHistoryName, setDispatchHistoryName] = useState("")
    const [onOff, setOnOff] = useState(false)
    const [openApply, setOpenApply] = useState(false);
    const [openSaveReplace, setSaveReplaceOpen] = useState(false);
    const [patternId, setPatternId] = useState(0);

    const handleApplyClickOpen = () => {
        setOpenApply(true);
    };
    const handleApplyClose = () => {
        setOpenApply(false);
    };
    const handleApplySuccessClose = () => {
        handleApplySlotConfiguration();
        setOpenApply(false);
    }
    const handleSaveReplaceClickOpen = () => {
        setSaveReplaceOpen(true);
    };
    const handleSaveReplaceClose = (value) => {
        setSaveReplaceOpen(false);
        if(value === t('create')) {
            _handleSaveDispatchHistory();
        } else if(value === t('update')) {
            let slotConfigurationStr = transferSlotConfigurationStr();
            dispatch(saveSortingHistory(undefined, undefined, undefined, slotConfigurationStr, props.historyId))
            .then(() => {
                dispatch(showAlertSnackbar({message: t('save_success_message'), type: 'success'}))
            })
            .catch(error => {
                dispatch(showAlertSnackbar({message: t('save_fail_message'), type: 'error'}))
                dispatch(showAlertSnackbar({title: "Unable to create dispatch history", message: error.message}))
            })
        }
    };
    
    useEffect(() => {
        setPatternId(0);
    }, [])
    useEffect(() => {
        props.handlePatternId(patternId);
    }, [patternId])

    return (
        <div className={classes.container}>
            <Dialog
                open={openApply}
                onClose={handleApplyClose}
            >
                <DialogTitle id="alert-dialog-title">{t('title_apply')}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {t('apply_confirm_content')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                <Button onClick={handleApplyClose} color="primary">
                    {t('cancel')}
                </Button>
                <Button onClick={handleApplySuccessClose} color="primary" autoFocus>
                    {t('confirm')}
                </Button>
                </DialogActions>
            </Dialog>
            <UniDialog
                title={t('dialog:save_dispatch_history_title')}
                message={t('dialog:save_dispatch_history_message')}
                fullWidth
                open={openSaveDispatchHistoryDialog}
                onClose={()=>dispatch(handleSaveDispatchHistoryDialogSlot(false))}
                onFinish={handleSaveDispatchHistory}
            >
                <TextField
                    autoFocus
                    fullWidth
                    onBlur={(e)=> setDispatchHistoryName(e.target.value)}
                />
            </UniDialog>
            <SaveReplace open={openSaveReplace} onClose={handleSaveReplaceClose}/>
            <div className={`${classes.row} ${classes.batchAction}`}>
                <div style={{display: 'flex', flexDirection: 'row', flexGrow: 1}}>
                    { props.selectedBatchIds.length <= 0 ? <Report color='error' style={{marginRight: 12}}/> : null}
                    <Tooltip title={props.selectedBatchIds.toString()}>
                        <Typography>{displayBatches(props.selectedBatchIds)}</Typography>
                    </Tooltip>
                    { props.selectedBatchIds.length > 0 ?
                        <Tooltip title='Copy Batch References'>
                            <IconButton aria-label="copy-batch-ids" size="small" onClick={()=>{handleCopyBatchIds(props.selectedBatchIds)}}>
                                <FileCopy fontSize="inherit"/>
                            </IconButton>
                        </Tooltip>
                        : null}
                </div>                
            </div>
            <div className={`${classes.row} ${classes.batchAction}`}>
                { props.selectedBatchIds.length > 0 ?
                 <Button 
                    onClick={saveOrReplace} 
                    variant="contained" 
                    color="secondary"
                    className={classes.buttonStyle}
                    >{t('save_configuration')}</Button>: null}
                <Button
                    onClick={()=>dispatch(handleLoadBatchIdDialogSlot(true))}
                    variant="contained" 
                    color="secondary"
                    className={classes.buttonStyle}
                >{t('load_configuration')}</Button>
                <Button
                    variant="contained" 
                    color="secondary"
                    className={classes.buttonStyle}
                    disabled
                >{t('auto_assign')}</Button>
                <Button
                    variant="contained" 
                    color="secondary"
                    className={classes.buttonStyle}
                    onClick={() => {
                        props.handleEnableManualEdit();
                        setOnOff(!onOff);
                        }
                }>
                    {onOff ? <DoneIcon/> : <NotInterestedOutlinedIcon/>}{t('manual_edit')}</Button>
                { props.selectedBatchIds.length > 0 ?
                <Button
                    variant="contained" 
                    color="secondary"
                    onClick={handleApplyClickOpen}
                    className={classes.buttonStyle}
                >{t('common:apply')}</Button>: null }
                <Button 
                    onClick={props.handleClear} 
                    variant="contained" 
                    color="secondary"
                    className={classes.buttonStyle}
                    >{t('clear')}</Button>
            </div>
            <div>
                <Select
                    variant='outlined'
                    value={patternId}
                    onChange={(event)=>{setPatternId(event.target.value)}}
                >
                {
                    patternIdTypes &&
                    patternIdTypes.map((pattern) => (
                        <MenuItem value={pattern.pattern_id}>{pattern.pattern_id}</MenuItem>
                    ))
                }
                </Select>
            </div>
        </div>
    )

    function saveOrReplace() {
        if(props.historyId) {
            handleSaveReplaceClickOpen();
        } else {
            _handleSaveDispatchHistory();
        }
    }

    function transferSlotConfigurationStr() {
        // const slotConfiguration = JSON.stringify(props.newSlotConfiguration);
        // return slotConfiguration;
        const slotConfiguration = props.newSlotConfiguration;
        let slotConfigurationStr = '';
        for(const slot in slotConfiguration) {
            if(slot !== undefined) {
                slotConfigurationStr = slotConfigurationStr.concat(',' + slot + ':' + slotConfiguration[slot]);
            }           
        }
        slotConfigurationStr = slotConfigurationStr.substring(1);
        return slotConfigurationStr;
    }

    function displayBatches(batchIds){
        if(batchIds.length <= 0) {
            return t('no_batch_selected')
        } else if (batchIds.length == 1) {
            return `${t('batch_id')} ${batchIds[0]}`
        } else {
            let batchesStr = '';
            for(const batch of batchIds) {
                batchesStr = batchesStr.concat(', ' + batch);
            }
            batchesStr = batchesStr.substring(1);
            return `${t('batch_id')} ${batchesStr} (${batchIds.length})`
        }
    }

    function handleApplySlotConfiguration() {
        let slotConfigurationStr = transferSlotConfigurationStr();
        dispatch(applyConfiguration(props.selectedBatchIds.toString(), slotConfigurationStr))
        .then((res) => {
            dispatch(showAlertSnackbar({mesage: t('reset_success_message'), type: 'success'}))
        })
        .catch(() => {
            dispatch(showAlertSnackbar({message: t('reset_fail_message'), type: 'error'}))
        })
    }

    function _handleSaveDispatchHistory() {
        dispatch(handleSaveDispatchHistoryDialogSlot(true))
    }

    function handleCopyBatchIds(batchIds){
        navigator.clipboard.writeText(batchIds.toString())
        dispatch(showAlertSnackbar({title: 'Copy Batch', message: 'You have successfully copied batch referer ids!', type: 'success'}))
    }

    function handleSaveDispatchHistory(){
        if(dispatchHistoryName.length <= 0 || props.selectedBatchIds.length <= 0){
            dispatch(showAlertSnackbar({title: "Unable to create dispatch history", message: "Dispatch group name cannot be empty!"}))
            return
        }
        const warehouse = props.branch;
        const owner = userPref.username;
        const name = dispatchHistoryName;
        let slotConfigurationStr = transferSlotConfigurationStr();
        dispatch(saveSortingHistory(warehouse, owner, name, slotConfigurationStr))
        .then(() => {
            dispatch(showAlertSnackbar({message: t('save_success_message'), type: 'success'}))
        })
        .catch(error => {
            dispatch(showAlertSnackbar({message: t('save_fail_message'), type: 'error'}))
            dispatch(showAlertSnackbar({title: "Unable to create dispatch history", message: error.message}))
        })
    }
}

BatchInfo.defaultProps = {
    selectedBatchIds: []
}


export default BatchInfo;